import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import config from 'constants/apiConfig';
import { toast } from 'react-toastify';
import { parseError } from '../shared/error';
import { internalLayersKeys } from './queryKeys';
import type {
  InternalLayer,
  UpdateInternalLayerBody,
} from 'hooks/internalLayer/types';
import { layerNodesKeys } from 'hooks/layerNode/queryKeys';
import { internalLayerVersionsKeys } from 'hooks/internalLayerVersion/queryKeys';

export function useUpdateInternalLayerMutation() {
  const queryClient = useQueryClient();

  return useMutation<
    InternalLayer,
    undefined,
    { internalLayerId: UUID } & UpdateInternalLayerBody
  >({
    mutationFn: async ({ internalLayerId, ...patch }) => {
      const resp = await axios.patch<InternalLayer>(
        `${config.apiGateway.internal_layers}/${internalLayerId}`,
        patch
      );
      return resp.data;
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: internalLayersKeys.get(variables.internalLayerId),
      });

      toast.success('Internal layer updated.');
    },
    onError: (error) => {
      toast.error(parseError(error));
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: internalLayersKeys.all() });
      queryClient.invalidateQueries({ queryKey: layerNodesKeys.all() });
      queryClient.invalidateQueries({
        queryKey: internalLayerVersionsKeys.all(),
      });
    },
  });
}
